"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
class AuthNextApiClient {
    constructor(basePath) {
        this.basePath = basePath;
    }
    getEndpoint(action, provider) {
        return [`${this.basePath}/${action}`, provider].filter(Boolean).join('/');
    }
    fetchAction(action, requestInit = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const { provider, headers = null, data } = requestInit, otherOptions = __rest(requestInit, ["provider", "headers", "data"]);
            try {
                const response = yield fetch(this.getEndpoint(action, provider), Object.assign(Object.assign({ method: 'POST', body: data ? JSON.stringify(data) : undefined, cache: 'no-cache', credentials: 'same-origin', redirect: 'error' }, otherOptions), { headers: new Headers(Object.assign({ 'Content-Type': `application/json` }, headers)) }));
                let text = yield response.text();
                if (response.status !== 200) {
                    return {
                        error: text,
                    };
                }
                try {
                    text = JSON.parse(text);
                    // eslint-disable-next-line no-empty
                }
                catch (e) { }
                return {
                    payload: text,
                };
            }
            catch (e) {
                return { error: e.message };
            }
        });
    }
    getTokens() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetchAction(`tokens`, {
                method: 'GET',
            });
        });
    }
    login(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetchAction(`login`, {
                data,
            });
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetchAction(`logout`);
        });
    }
    resetPassword(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetchAction(`reset-password`, {
                data,
            });
        });
    }
    resetPasswordConfirm(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetchAction(`reset-password-confirm`, { data });
        });
    }
    changePassword(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetchAction(`change-password`, { data });
        });
    }
    b2bLogin(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetchAction(`b2b-login`, {
                data,
            });
        });
    }
    b2bForgotPassword(username) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetchAction(`b2b-forgot-password`, {
                data: {
                    username,
                },
            });
        });
    }
    getCrossLoginPath() {
        return this.getEndpoint(`cross-login`);
    }
    getSocialLoginPath(provider) {
        return this.getEndpoint(`social`, provider);
    }
}
exports.default = AuthNextApiClient;
/*
      'GET /tokens': createGetTokensHandler(),
      'POST /logout': createLogoutHandler(),
      'POST /reset-password': createB2CResetPasswordHandler(),
      'POST /reset-password-confirm': createB2CResetPasswordConfirmHandler(),
      'POST /change-password': createB2CChangePasswordHandler(),
      'GET /cross-login': createB2CCrossLoginHandler(),
      'GET /social': createB2CSocialHandler(provider),
      'GET /social-back': createSocialBackHandler(),
      'POST /b2b-login': createB2BLoginHandler(),
      'POST /b2b-auto-login': createB2BAutoLoginHandler(),
      'POST /auto-login': createAutoLoginHandler(),
      'POST /b2b-forgot-password': createB2BForgotPasswordHandler(),
* */
//# sourceMappingURL=AuthNextApiClient.js.map